// extracted by mini-css-extract-plugin
export var inputTwoCol = "contact-form-module--input-two-col--3FJxN";
export var contactForm = "contact-form-module--contact-form--18kZo";
export var thankyouPage = "contact-form-module--thankyou-page--17Gb5";
export var dotFlashing = "contact-form-module--dot-flashing--3wt1v";
export var dots = "contact-form-module--dots--2qiTG";